import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

// Enhanced preload images function with loading states
function preloadImages(imageUrls, onImageLoad) {
  let loadedCount = 0;
  const totalImages = imageUrls.length;
  
  imageUrls.forEach((url) => {
    const img = new Image();
    img.onload = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        onImageLoad();
      }
    };
    img.onerror = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        onImageLoad();
      }
    };
    img.src = url;
  });
}

function MainLinks({ setBackgroundImage, setBgPosition }) {

    const links = [
        { 
          text: 'ALEXA FLUOR', 
          slug: 'alexa-fluor', 
          bg: '/images/AlexaFluor-Portrait.jpg',
        },
        { 
          text: 'CAROTIN', 
          slug: 'carotin', 
          bg: '/images/Carotin-Portrait-2.jpg',
        },
        {
          text: 'ELOISA',
          slug: 'eloisa',
          bg: '/images/ELOISA-Portrait-2.jpeg',
        },
        {
          text: 'GIANNI',
          slug: 'gianni',
          bg: '/images/Gianni-Portrait.jpg',     
        },
        {
          text: 'MAUDUX',
          slug: 'maudux',
          bg: '/images/Maudux-Portrait.jpg',     
        },
        {
          text: 'MELANCHROMIE',
          slug: 'melanchromie',
          bg: '/images/Melanchromie-Portrait-2.jpg',
        },
        {
          text: 'MILLIE FORSBERG',
          slug: 'millie-forsberg',
          bg: '/images/MillieForsberg-Portrait.jpg',
        },
        {
          text: 'SHANIXX',
          slug: 'shanixx',
          bg: '/images/Shanixx-Portrait.jpg',
        },
      ];

  useEffect(() => {
    const imageUrls = links.map(link => link.bg);
    preloadImages(imageUrls, () => {
      // Images preloaded, but no loading state needed
    });
  }, []);

  const handleMouseEnter = (link) => {
    setBackgroundImage(link.bg);
    setBgPosition(link.bgPosition || 'center');
  };

  const handleMouseLeave = () => {
    setBackgroundImage(null);
    setBgPosition('center');
  };

  // Mobile touch handlers
  const handleTouchStart = (link) => {
    setBackgroundImage(link.bg);
    setBgPosition(link.bgPosition || 'center');
  };

  const handleTouchEnd = () => {
    // Small delay to allow navigation to complete
    setTimeout(() => {
      setBackgroundImage(null);
      setBgPosition('center');
    }, 100);
  };

  return (
    <div className="main-links">
      {links.map((link, index) => (
        <Link
          key={index}
          to={`/artist/${link.slug}`}
          className="link-hover"
          onMouseEnter={() => handleMouseEnter(link)}
          onMouseLeave={handleMouseLeave}
          onTouchStart={() => handleTouchStart(link)}
          onTouchEnd={handleTouchEnd}
        >
          {link.text}
        </Link>
      ))}
    </div>
  );
}

export default MainLinks;